export default {
	//双表头处理
	tableHeard: function(item) {
		var arr = [];
		Object.keys(item).forEach(function(k) {
			arr.push(k);
		});
		return arr;
	},
	//双表头处理
	tableHeardData: function(item, sum) {
		var arr = [];
		var childArr = [];
		var ltop = '';
		var len = 0;
		$.each(item, function(key, i) {
			var lineNumObj = {};
			len++;
			if(key.indexOf('_') != -1) {

				var obj = {};
				var f = key.split('_')[0];
				var l = key.split('_')[key.split('_').length - 1];
				if(ltop != f && ltop != "") {

					lineNumObj.name = ltop;
					lineNumObj.child = childArr;
					arr.push(lineNumObj);
					childArr = [];

				}

				obj.name = l;
				obj.label = key;
				obj.value = i;
				childArr.push(obj);

				ltop = f;

				if(len == sum) {

					lineNumObj = {};
					lineNumObj.name = ltop;
					lineNumObj.child = childArr;
					arr.push(lineNumObj);
					childArr = [];
				}

			} else {
				lineNumObj.name = key;
				lineNumObj.label = key;
				lineNumObj.value = i;
				lineNumObj.child = null;
				ltop = '';
				arr.push(lineNumObj)
			}

		});

		return arr;
	},
	getIP: function(ip) {
		var dataIp = '';
		$.ajax({
			type: 'post',
			async: false,
			cache: false,
			dataType: 'json',
			url: '../ExamAPI/Common/Project/GetConfingKey',
			data: {
				"con_key": "ProjectAPIUrl"
			},
			success: function(data) {
				if(data.result == true) {
					console.log(data.datas, ' data.datas data.datas');
					dataIp = data.datas;

				} else {
					dataIp = '';
				}
			},
			error: function(data) {
				return;
			}
		});
		if(dataIp == '') {
			return '../ExamAPI/';
		} else {
			return dataIp;
		}
	},
	//获取时间戳
	getTimeStamp: function() {
		var date = new Date();
		return date.getTime() + '';
	},
	// 获取随机数[0-9,a-z,A-Z]随机产生10位随机数
	getRandom: function() {
		/**
		 * 1、定义随机数的数组
		 * 2、获取数组的下标组成新的字符型
		 */
		var randomArr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't',
			'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
		]
		var newStr = '';
		for(var i = 0; i < 5; i++) {
			var index = parseInt(Math.random() * randomArr.length);
			newStr += randomArr[index];
		}
		return newStr
	},
	//获取签名
	GetSigna: function(jQueryString,token, time, nonce, type,apiUrl) {
		var Signa;
		$.ajax({
			async: false,
			cache: false,
			url: apiUrl+ '/Common/User/GetSignature',
			dataType: 'json',
			type: type,
			data: jQueryString,
			//                  contentType: "application/x-www-form-urlencoded, multipart/form-data",
			beforeSend: function(request) {
				request.setRequestHeader("token", token);
				request.setRequestHeader("timestamp", time);
				request.setRequestHeader("nonce", nonce);
			},
			success: function(data) {
				Signa = data.datas;
			},
			error: function(msg) {}
		});
		return Signa;
	},

}



// WEBPACK FOOTER //
// ./src/role.js